export default [
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/Index.vue')
    }
]